import { LoadTaskComponent } from './all/instance-liquidation/load-task/load-task.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


const routes: Routes = [
    { path: 'liquidations/:tramite_id', component: LoadTaskComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class FormsRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/forms/form-routing.module.ts